









import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class ShebaView extends Vue {
  @Prop() model!: number | string

  get __value() {
    if (this.$attrs.hasOwnProperty('separate'))
      return (this.model) ? this.model.toString().match(/.{1,4}/g).join('-') : 'ندارد'
    if (this.$attrs.hasOwnProperty('mask')) {
      let str = (this.model) ? this.model.toString() : ''
      return (this.model) ? str.slice(str.length - 4).concat(' *** ', str.slice(0, 6)) : 'ندارد'
    }

  }

}
